export default __webpack_public_path__ + "static/assets/3f0c095ecf032f9a670a032515ae3dcb.svg";